var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('el-card',[_c('alter-form',{ref:"alterForm",attrs:{"labelWidth":"160px","modifyData":_vm.modifyData,"formData":_vm.formData,"collapseLength":_vm.collapseLength},on:{"handleChange":_vm.handleChange,"formSubmit":_vm.formSubmit}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }